import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { protectedResources } from '../auth/auth.config';
import {
  LicensedProductComponentListDto,
  LicensedProductDto,
  LicensedProductListDto,
} from '../models/license.model';

@Injectable({
  providedIn: 'root',
})
export class LicensedProductService {
  private apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  constructor(private http: HttpClient) {}

  getAll(): Observable<LicensedProductListDto> {
    return this.http.get<LicensedProductListDto>(
      `${this.apiEndpoint}/licenses/products`,
    );
  }

  create(payload: LicensedProductDto): Observable<LicensedProductDto> {
    return this.http.post<LicensedProductDto>(
      `${this.apiEndpoint}/licenses/products`,
      payload,
    );
  }

  getById(productId: string): Observable<LicensedProductDto> {
    const encodedProductId = encodeURIComponent(productId);
    return this.http.get<LicensedProductDto>(
      `${this.apiEndpoint}/licenses/products/${encodedProductId}`,
    );
  }

  update(
    productId: string,
    payload: LicensedProductDto,
  ): Observable<LicensedProductDto> {
    const encodedProductId = encodeURIComponent(productId);
    return this.http.put<LicensedProductDto>(
      `${this.apiEndpoint}/licenses/products/${encodedProductId}`,
      payload,
    );
  }

  delete(productId: string): Observable<void> {
    const encodedProductId = encodeURIComponent(productId);
    return this.http.delete<void>(
      `${this.apiEndpoint}/licenses/products/${encodedProductId}`,
    );
  }

  getComponentsForLicensedProduct(
    thirdPartyOnly = false,
  ): Observable<LicensedProductComponentListDto> {
    const params = new URLSearchParams();
    if (thirdPartyOnly) {
      params.set('kind', 'THIRD_PARTY_SERVICE');
    }
    return this.http.get<LicensedProductComponentListDto>(
      `${this.apiEndpoint}/licenses/products/components?${params.toString()}`,
    );
  }
}
